var React = require('react');

function Live (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"450","height":"160","rx":"80","fill":"#DC2626","key":0}),React.createElement("g",{"className":"animate-pulse","key":1},[React.createElement("circle",{"cx":"370","cy":"81","r":"28","fill":"#fff","key":0}),React.createElement("circle",{"cx":"369.5","cy":"80.5","r":"41.5","stroke":"#fff","strokeWidth":"8","key":1})]),React.createElement("path",{"d":"M116.297 106.203V119H76.211v-12.797h40.086ZM81.516 39.375V119H65.109V39.375h16.407Zm61.632 0V119h-16.351V39.375h16.351Zm44.079 63 18.757-63h18.266L196.523 119h-12.031l2.735-16.625Zm-17.282-63 18.703 63L191.492 119h-12.14l-27.563-79.625h18.156Zm115.172 66.828V119h-42.383v-12.797h42.383Zm-37.023-66.828V119h-16.406V39.375h16.406Zm31.5 32.43v12.468h-36.86V71.805h36.86Zm5.468-32.43v12.852h-42.328V39.375h42.328Z","fill":"#fff","key":2})]);
}

Live.defaultProps = {"fill":"none","viewBox":"0 0 450 160"};

module.exports = Live;

Live.default = Live;
